import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonCheckbox,
  IonContent,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonPage,
  IonPopover,
  IonSegment,
  IonSegmentButton,
  IonSelect,
  IonSelectOption,
  IonTitle,
  IonToolbar,
  useIonViewWillEnter,
} from "@ionic/react";
import {
  createTemplate,
  getDomains,
  getTemplateById,
  getTemplatePlaceholders,
  updateTemplate,
} from "misc/phqHTTP";
import { MessageTemplate } from "models/message-template.model";
import React, { useContext, useReducer, useState } from "react";
import { useHistory, useParams } from "react-router";
import { AppContext } from "context/app.context";
import { PHQDomain } from "models/domain.model";
import { MessageTemplateAction } from "models/message-template-action.enum";
import { informationCircleOutline, save } from "ionicons/icons";
import MessageBody from "./MessageBody";
import startCase from 'lodash-es/startCase'
import Footer from "layout/footer";

const AddEditTemplate = () => {
  const { id } = useParams<{ id: string }>();
  const { notifySuccess } = useContext(AppContext);
  const history = useHistory();

  const reducer = (
    state: MessageTemplate,
    stateUpdate: Partial<MessageTemplate>
  ) => {
    return { ...state, ...stateUpdate };
  };

  const [template, dispatch] = useReducer(reducer, {} as MessageTemplate);
  const [domains, setDomains] = useState<PHQDomain[]>([]);
  const [letterCount, setLetterCount] = useState(0);
  const [isHTML, setIsHMTL] = useState(!!template.EmailHTML);
  const [editor, setEditor] = useState("rich");
  const [placeholders, setPlaceholders] = useState<string[]>([]);
  const [popoverState, setShowPopover] = useState({
    showPopover: false,
    event: undefined,
  });
  const isEditMode = Number(id) > 0;

  const onSave = () => {
    if (isEditMode) {
      updateTemplate(template).then((res) => {
        notifySuccess("Template updated");
      });
    } else {
      createTemplate(template).then((res) => {
        notifySuccess("Template added");
        history.goBack();
      });
    }
  };

  useIonViewWillEnter(() => {
    getTemplatePlaceholders().then((res) => {
      setPlaceholders(res.data.result);
    });
    getDomains().then((res) => {
      setDomains(res.data.result);
    });
    if (isEditMode) {
      getTemplateById(+id).then((res) => {
        setLetterCount(res.data.result.Text?.length);
        dispatch(res.data.result);
      });
    }
  });

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary" className="ion-no-border">
          <IonButtons slot="start">
            <IonBackButton defaultHref="/templates" />
          </IonButtons>
          <IonTitle className="ion-text-center">
            {isEditMode ? "EDIT" : "ADD"} TEMPLATE
          </IonTitle>
          <IonButton slot="end" size="default" onClick={(e) => onSave()}>
            <IonIcon icon={save} slot="icon-only"></IonIcon>
          </IonButton>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonCard>
          <IonCardHeader className="py-2" color="primary">
            <IonCardTitle>SETTINGS</IonCardTitle>
          </IonCardHeader>
          <IonCardContent className="mt-3">
            <IonItem>
              <IonLabel>Domain</IonLabel>
              <IonSelect
                placeholder="Domain"
                value={template.DomainID}
                onIonChange={(e) => dispatch({ DomainID: e.detail.value })}
              >
                {domains.map((d) => {
                  return (
                    <IonSelectOption key={d.DomainID} value={d.DomainID}>
                      {d.Name}
                    </IonSelectOption>
                  );
                })}
              </IonSelect>
            </IonItem>
            <IonItem>
              <IonLabel>Action</IonLabel>
              <IonSelect 
                placeholder="Action"
                value={template.Action}
                onIonChange={(e) => dispatch({ Action: e.detail.value })}
              >
                {Object.keys(MessageTemplateAction)
                  .filter((a) => isNaN(+a))
                  .map((action, idx) => {
                    return (
                      <IonSelectOption key={idx} value={action}>
                        {startCase(action)}
                      </IonSelectOption>
                    );
                  })}
              </IonSelect>
            </IonItem>
            <IonItem>
              <IonLabel>HTML Email Body</IonLabel>
              <IonCheckbox
                checked={isHTML}
                onIonChange={(e) => setIsHMTL(e.detail.checked)}
              ></IonCheckbox>
            </IonItem>
          </IonCardContent>
        </IonCard>

        <IonCard>
          <IonCardHeader className="py-2" color="primary">
            <IonCardTitle>SMS</IonCardTitle>
          </IonCardHeader>
          <IonCardContent className="mt-3">
            <div className="d-flex justify-content-between">
              <div className="d-flex my-auto">
                <b>Message Body &nbsp;</b>
                <IonIcon 
                  onClick={(e: any) => { e.persist(); setShowPopover({showPopover: !popoverState.showPopover, event: e})} } 
                  style={{fontSize: 'x-large'}}
                  icon={informationCircleOutline}>
                  </IonIcon>
              </div>
              <span>{letterCount}</span>
            </div>
            <MessageBody
              id="Text"
              charLimit={140}
              value={template.Text}
              onChange={(val) => {
                dispatch({ Text: val });
                setLetterCount(val.length);
              }}
              placeholders={placeholders}
            ></MessageBody>
          </IonCardContent>
        </IonCard>
        <IonCard>
          <IonCardHeader className="py-2" color="primary">
            <IonCardTitle>EMAIL</IonCardTitle>
          </IonCardHeader>
          <IonCardContent className="mt-3">
            <b>Subject</b>
            <IonInput
              className="email-subject mb-3"
              value={template.EmailSubject}
              onIonChange={(e:any) => dispatch({ EmailSubject: e.detail.value! }) } 
            />
            <b>Message Body</b>
            {isHTML ? (
              <div>
                <IonSegment
                  className="mb-2 mt-2"
                  value={editor}
                  onIonChange={(e) => setEditor(e.detail.value!)}
                >
                  <IonSegmentButton value="rich">
                    <IonLabel>Rich Text</IonLabel>
                  </IonSegmentButton>
                  <IonSegmentButton value="raw">
                    <IonLabel>Raw HTML</IonLabel>
                  </IonSegmentButton>
                </IonSegment>
                {editor === "rich" && (
                  <MessageBody
                    id="EmailHTML"
                    richEditor
                    value={template.EmailHTML}
                    onChange={(val) => dispatch({ EmailHTML: val })}
                    placeholders={placeholders}
                  ></MessageBody>
                )}
                {editor === "raw" && (
                  <MessageBody
                    id="EmailHTML"
                    value={template.EmailHTML}
                    onChange={(val) => dispatch({ EmailHTML: val })}
                    placeholders={placeholders}
                  ></MessageBody>
                )}
              </div>
            ) : (
              <MessageBody
                id="EmailText"
                value={template.EmailText}
                onChange={(val) => dispatch({ EmailText: val })}
                placeholders={placeholders}
              ></MessageBody>
            )}
          </IonCardContent>
        </IonCard>
        <IonButton
          className="mb-5"
          size="large"
          expand="full"
          onClick={(e) => onSave()}
        >
          <b>SAVE</b>
        </IonButton>
        <div style={{height: '100px'}}></div>
      </IonContent>
      <IonPopover
        cssClass="w-100"
        event={popoverState.event}
        isOpen={popoverState.showPopover}
        onDidDismiss={() => setShowPopover({ showPopover: false, event: undefined })}
      >
        <h3 className="text-center">PRO Tip</h3>
        <p>Press <b>Ctrl + .</b>(dot) to bring up placeholder list</p>
      </IonPopover>
      <Footer />
    </IonPage>
  );
};

export default AddEditTemplate;
